export default __webpack_public_path__ + "c4e210c9e74f192418ca88e6026bd81e.png";